import React, { Fragment, Component, useState, useEffect, useRef } from "react";
import { useHistory, Redirect } from 'react-router-dom';
import useForm from '../useForm';
import { BrowserRouter, Link, Switch, Route } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { toast } from "react-toastify";

import Slider from "react-slick";

import bg1 from "../../../assets/utils/images/originals/AFP-ERP-1.jpg";
import bg2 from "../../../assets/utils/images/originals/AFP-ERP-2.jpg";
import bg3 from "../../../assets/utils/images/originals/AFP-ERP-3.jpg";
import avior from "../../../assets/utils/images/originals/AviorsysNew.jpg";

import { Col, Row, Button, Form, FormGroup, Label, Input, Progress } from "reactstrap";
import { common } from "../../../Helpers/Shared";
import AppMain from "../../../Layout/AppMain";
import ForgotPassword from "./ForgotPassword";
// import GitInfo from 'react-git-info/macro';

const initialFieldValues = {
  UserName: '',
  Password: '',

}
let settings = {
  dots: true,
  infinite: false,
  speed: 500,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  initialSlide: 0,
  autoplay: true,
  adaptiveHeight: true,
};

export default function Login() {
  const userNameInput = useRef(null);
  let history = useHistory();
  const [isLoginSuccess, setLoginSuccess] = useState(false);
  const [isForgetPasswordView, setForgetPasswordView] = useState(false);

  //--------------Added on 08/06/2025 (ticket #33)---------------------
const [showResetPassword, setShowResetPassword] = useState(false);
const [resetSuccess, setResetSuccess] = useState(false);

const [resetData, setResetData] = useState({
  UserName: '',
  Password: '',
  ConfirmPassword: ''
});

const [resetErrors, setResetErrors] = useState({});

const [passwordStrength, setPasswordStrength] = useState(0);

const [showLoginPassword, setShowLoginPassword] = useState(false);

const [showNewPassword, setShowNewPassword] = useState(false);

const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//-------------------------------------------------------------------


  useEffect(() => {
    userNameInput.current.focus();
  }, []);

  const handleSubmit = e => {
    e.preventDefault()
    if (validate()) {
      setLoginSuccess(true);
      common.sendPostRequest(values, 'User')
        .then((response) => { signInSuccess(response) })
        .catch((error) => { signInSuccessErrorHandling(error.response) });
    }

  }
  // const signInSuccess = (result) => {
  //   if (result != null) {
  //     //--------------Added on 08/06/2025 (ticket #33)---------------------
  //     if (result.data.IsTempPassword == false){
  //       setLoginSuccess(false);
  //       localStorage.setItem('currentUser', JSON.stringify(result.data));
  //       history.push('/#/dashboards/crm');
  //     }
  //     else{
  //       setResetData({
  //         UserName: values.UserName,
  //         Password: '',
  //         ConfirmPassword: ''
  //       });
        
  //       setShowResetPassword(true);
  //       setLoginSuccess(false);
  //     }
  //     //-------------------------------------------------------------------
  //   }
  // }
  const signInSuccess = (result) => {

    if (result != null) {
  
      // Password expiry check
      if (result.data.PasswordModifiedDate) {
  
        const passwordModifiedDate = new Date(result.data.PasswordModifiedDate);
  
        const today = new Date();
  
        const monthsDifference =
          (today.getFullYear() - passwordModifiedDate.getFullYear()) * 12 +
          (today.getMonth() - passwordModifiedDate.getMonth());
  
        if (monthsDifference >= 3) {
  
          toast.warning(
            'Your password has been expired. You should update it.'
          );
  
          setResetData({
            UserName: values.UserName,
            Password: '',
            ConfirmPassword: ''
          });
  
          setShowResetPassword(true);
          setLoginSuccess(false);
  
          return;
        }
      }
  
      // Existing temporary password logic
      if (result.data.IsTempPassword == false) {
  
        setLoginSuccess(false);
  
        localStorage.setItem(
          'currentUser',
          JSON.stringify(result.data)
        );
  
        history.push('/#/dashboards/crm');
  
      }
      else {
  
        setResetData({
          UserName: values.UserName,
          Password: '',
          ConfirmPassword: ''
        });
  
        setShowResetPassword(true);
        setLoginSuccess(false);
      }
    }
  }
  const signInSuccessErrorHandling = (error) => {
    setLoginSuccess(false);
    if(error!=undefined)
    {
      var errorData = error.data;
      if (error !== null && errorData.userId === -1) {
        var remainingLoginAttempt = 5 - (errorData.AttemptCount);
        localStorage.setItem("remainingLoginAttempt", remainingLoginAttempt);
        let errorMsg = "The username or password you entered is incorrect. You have " + remainingLoginAttempt + " more Login attempts left";
        error.error = errorMsg
        setErrors(error)
        return;
  
      }
      if (errorData.userId == -2 || errorData.userId == -4) {
        // let errorMsg = "You have been blocked from accessing this system. Please contact your system administrator or "+ <a href="www.google.com">Aviorsys support</a> +"to unlock your user account.";
        let errorMsg = <p>You have been blocked from accessing this system. Please contact your system administrator or <a href="https://www.aviorsys.com/contact-us.html" target="_blank"><u>Aviorsys support</u></a> to unlock your user account.</p>
  
        error.error = errorMsg;
        setErrors(error)
        return;
      }
      else{
          var obj={
            error:error.data.Message
          }
          setErrors(obj);
        }
    }
    else{
      var obj={
        error:"Server Error,Contact Administrator"
      }
      setErrors(obj);
    }
    

  }
  const signInAsDifferent = () => {
    history.push('/');
  }
  const validate = (fieldValues = values) => {
    let temp = {}
    if ('UserName' in fieldValues)
      temp.UserName = fieldValues.UserName ? "" : "Username cannot be empty."
    if ('Password' in fieldValues)
      temp.Password = fieldValues.Password ? "" : "Password cannot be empty."

    setErrors({
      ...temp
    })

    if (fieldValues == values)
      return Object.values(temp).every(x => x == "")
  }
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
  } = useForm(initialFieldValues, validate)

  const showValidateMsg = (field) => {
    if (errors[field]) {
      return <small className="text-danger" style={{ color: 'red' }}>{errors[field]}</small>
    }
  }
  const forgotPassword = () => {
    history.push('/reset-password');
  }
  const redirect = () => {
    setForgetPasswordView(true);
    history.push('/forget-password');

  }

  // const gitInfo = GitInfo();

//--------------Added on 08/06/2025 (ticket #33)---------------------
const passwordPolicy =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#^()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d@$!%*?&.#^()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/;

const calculatePasswordStrength = (password) => {
  let strength = 0;

  if (password.length >= 8) strength += 25;
  if (/[A-Z]/.test(password)) strength += 25;
  if (/\d/.test(password)) strength += 25;
  if (/[@$!%*?&.#^()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) strength += 25;

  return strength;
};

const handleResetPasswordChange = (e) => {
  const { name, value } = e.target;

  setResetData({
    ...resetData,
    [name]: value
  });

  if (name === 'Password') {
    setPasswordStrength(calculatePasswordStrength(value));
  }
};

const validateResetPassword = () => {

  let temp = {};
  if (!resetData.UserName) {
    temp.UserName = "Username cannot be empty.";
  }
  if (!resetData.Password) {
    temp.Password = "Password cannot be empty.";
  }
  else if (!passwordPolicy.test(resetData.Password)) {
    temp.Password =
      "Password must contain minimum 8 characters, at least one uppercase letter, one number and one special character.";
  }

  if (!resetData.ConfirmPassword) {
    temp.ConfirmPassword = "Confirm Password cannot be empty.";
  }
  else if (resetData.Password !== resetData.ConfirmPassword) {
    temp.ConfirmPassword = "Passwords do not match.";
  }

  setResetErrors(temp);

  return Object.keys(temp).length === 0;
};

const resetTemporaryPassword = () => {

  if (!validateResetPassword())
    return;

  common.sendPostRequest({
    UserName: resetData.UserName,
    Password: resetData.Password
  }, 'User/ResetTempPassword')
    .then((response) => {

      if (response &&
        response.data &&
        response.data.Success) {
    
        setResetSuccess(true);
        setShowResetPassword(false);
    }
    })
    .catch(() => {

      setResetErrors({
        error: "Unable to reset password."
      });

    });
};

const backToLogin = () => {

  setResetSuccess(false);
  setShowResetPassword(false);
  setLoginSuccess(false);

  setResetData({
    UserName: '',
    Password: '',
    ConfirmPassword: ''
  });

  setPasswordStrength(0);

  setResetErrors({});

  setValues({
    UserName: '',
    Password: ''
  });
};

const getStrengthColor = () => {

  if (passwordStrength <= 25)
    return "danger";

  if (passwordStrength <= 50)
    return "warning";

  if (passwordStrength <= 75)
    return "info";

  return "success";
};
//-------------------------------------------------------------------

//----------------------Added on 17/06/2025 (ticket #41)-----------------------------
const passwordChecks = {
  minLength: resetData.Password.length >= 8,
  uppercase: /[A-Z]/.test(resetData.Password),
  number: /\d/.test(resetData.Password),
  special: /[@$!%*?&.#^()_+\-=\[\]{};':"\\|,.<>\/?]/.test(resetData.Password)
};
//-----------------------------------------------------------------------------------

  return (
    <Fragment>
    
     { !isForgetPasswordView  && <div className="h-100">
        <Row className="h-100 no-gutters">
          <Col lg="4" className="d-none d-lg-block">
            <div className="slider-light">
              <Slider {...settings}>
                <div className="h-100 d-flex justify-content-center align-items-center bg-plum-plate">
                  <div className="slide-img-bg"
                    style={{
                      backgroundImage: "url(" + bg1 + ")",
                    }} />
                  <div className="slider-content">
                  </div>
                </div>
                <div className="h-100 d-flex justify-content-center align-items-center bg-premium-dark">
                  <div className="slide-img-bg"
                    style={{
                      backgroundImage: "url(" + bg3 + ")",
                    }} />
                  <div className="slider-content">
                   
                  </div>
                </div>
                <div className="h-100 d-flex justify-content-center align-items-center bg-sunny-morning">
                  <div className="slide-img-bg opacity-6"
                    style={{
                      backgroundImage: "url(" + bg2 + ")",
                    }} />
                  <div className="slider-content">
                  </div>
                </div>
              </Slider>
            </div>
          </Col>
          <Col lg="8" md="12" className="h-100 d-flex bg-white justify-content-center align-items-center">
            <Col lg="9" md="10" sm="12" className="mx-auto app-login-box">
              {/* <div className="app-logo" /> */}
              <img src={avior} style={{ width: 400 }} />
              {/* <h4 className="mb-0">
                <div>Welcome !!</div>
                {/* <span>Please sign in to your account.</span> 
              </h4> */}
              {/* <h6 className="mt-3">
                  No account?{" "}
                  <a href="https://colorlib.com/" onClick={(e) => e.preventDefault()} className="text-primary">
                    Sign up now
                  </a>
                </h6> */}
              <Row className="divider" />
              <div>
              {!showResetPassword && !resetSuccess && (

<form autoComplete="off" onSubmit={handleSubmit}>

  <Row form>

    <Col md={6}>
      <FormGroup>
        <Label>Username</Label>

        <Input
          type="text"
          name="UserName"
          value={values.UserName}
          onChange={handleInputChange}
          ref={userNameInput}
        />

        {showValidateMsg('UserName')}
      </FormGroup>
    </Col>

    <Col md={6}>
      <FormGroup>
        <Label>Password</Label>

        <div style={{ position: "relative" }}>
  <Input
    type={showLoginPassword ? "text" : "password"}
    name="Password"
    value={values.Password}
    onChange={handleInputChange}
  />

  <span
    onClick={() => setShowLoginPassword(!showLoginPassword)}
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      zIndex: 10
    }}
  >
    {/* <i className={`fa ${showLoginPassword ? "fa-eye-slash" : "fa-eye"}`}></i> */}
    <FontAwesomeIcon icon={showLoginPassword ? faEyeSlash : faEye}/>
  </span>
</div>

        {showValidateMsg('Password')}
      </FormGroup>
    </Col>

  </Row>

  <Row className="divider" />

  <div className="d-flex align-items-center">
    <div className="ml-auto">

      <Button
        color="primary"
        size="lg"
        type="submit"
        disabled={isLoginSuccess}
      >
        Login
      </Button>

    </div>
  </div>

  {errors.error &&
    <span className="text-danger">{errors.error}</span>}

</form>

)}

{showResetPassword && !resetSuccess && (

<div>

  <h5>Reset Password</h5>

  <FormGroup>
  <Label>Username</Label>

<Input
    type="text"
    name="UserName"
    value={resetData.UserName}
    onChange={handleResetPasswordChange}
    maxLength="50"
/>

{resetErrors.UserName &&
    <small className="text-danger">
        {resetErrors.UserName}
    </small>
}

    <Label>Password</Label>

    <div style={{ position: "relative" }}>
  <Input
    type={showNewPassword ? "text" : "password"}
    name="Password"
    value={resetData.Password}
    onChange={handleResetPasswordChange}
  />

  <span
    onClick={() => setShowNewPassword(!showNewPassword)}
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      zIndex: 10
    }}
  >
    <i className={`fa ${showNewPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
  </span>
</div>

    {resetErrors.Password &&
      <small className="text-danger">
        {resetErrors.Password}
      </small>}
  </FormGroup>

  <FormGroup>
    <Label>Confirm Password</Label>

    <div style={{ position: "relative" }}>
  <Input
    type={showConfirmPassword ? "text" : "password"}
    name="ConfirmPassword"
    value={resetData.ConfirmPassword}
    onChange={handleResetPasswordChange}
  />

  <span
    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      zIndex: 10
    }}
  >
    <i className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
  </span>
</div>

    {resetErrors.ConfirmPassword &&
      <small className="text-danger">
        {resetErrors.ConfirmPassword}
      </small>}
  </FormGroup>

  <Progress
    value={passwordStrength}
    color={getStrengthColor()}
    className="mb-2"
  />


<div className="mt-2">

<div
  style={{
    color: passwordChecks.minLength ? "green" : "red"
  }}
>
  {passwordChecks.minLength ? "✔" : "❌"} Minimum 8 characters
</div>

<div
  style={{
    color: passwordChecks.uppercase ? "green" : "red"
  }}
>
  {passwordChecks.uppercase ? "✔" : "❌"} At least one uppercase letter
</div>

<div
  style={{
    color: passwordChecks.number ? "green" : "red"
  }}
>
  {passwordChecks.number ? "✔" : "❌"} At least one number
</div>

<div
  style={{
    color: passwordChecks.special ? "green" : "red"
  }}
>
  {passwordChecks.special ? "✔" : "❌"} At least one special character
</div>


</div>

  <br />
  <br />

  <Button
    color="success"
    onClick={resetTemporaryPassword}
  >
    Reset
  </Button>

  {resetErrors.error &&
    <div className="text-danger mt-2">
      {resetErrors.error}
    </div>}
</div>

)}

{resetSuccess && (

<div className="text-center">

  <h4 className="text-success">
    Your password has been reset successfully.
  </h4>

  <br />

  <Button
    color="primary"
    onClick={backToLogin}
  >
    Back To Login
  </Button>

</div>

)}
              </div>
            </Col>
          </Col>
        </Row>
      </div>
      }
      {/* {isForgetPasswordView && <ForgotPassword/>} */}
    </Fragment>
  )
}
